var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirTrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000127016840984459794320000013331435541868175533_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68,62.7V33.6c0-15.4-12.5-28-28-28c-15.4,0-28,12.5-28,28v29.1H9.2v11.1h61.6V62.7H68z M13,33.6c0-14.9,12.1-27,27-27 c14.9,0,27,12.1,27,27v29.1H13V33.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirTrap);
export default __webpack_public_path__ + "static/media/airTrap.9eee6d93877b65ca99b3bf4967f8644a.svg";
export { ForwardRef as ReactComponent };